export class Token {
  static tokeNameInSotage = "tokenJWT";
  static refreshTokenNameInStorage = "refreshToken";
}
